import { createCrudActions } from '../utils/crudGenerator';

const formatWastetypes = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchWastetypes,
    create: createWastetype,
    update: updateWastetype,
    delete: deleteWastetypes
} = createCrudActions('WASTETYPE', "Tipo De Residuo", formatWastetypes);